import {useStoreContext} from '../../../../../../store/store-context';
import {Active} from '../admin-member/admin-member-components/active-member/active';
import {Invite} from '../admin-member/admin-member-components/invited-member/invite';
import {Deactivate} from '../admin-member/admin-member-components/deactivated-member/deactivate';
import {observer} from 'mobx-react';
import {useEffect} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {useQuery} from 'react-query';
import {UserAPIController} from '../../../../../../api/user-api/user-api-controller';
import {UserAPIRequestImpl} from '../../../../../../api/user-api/user-api-request';
import {Button} from '../../../../../../ui/atoms/button';
import {
  MemberPage,
  MemberPageHeader,
  MemberPageHeading,
  MemberPageSubtitle,
  MemberPageTitle,
  MemberSegment,
  MemberSegments,
} from './member-redesign.styles';

export const AdminMemberPage = observer(() => {
  const {
    storeDashboardRoutes,
    authStore: {auth, openGlobalUserInvitationModal},
  } = useStoreContext();
  const {memberTab, activateMemberTab} = storeDashboardRoutes;

  const location = useLocation();
  const navigate = useNavigate();
  const isFreePlanActive = auth.user.workspace.billing.plan === 'free_tier';

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.get('invite') !== 'true') return;
    openGlobalUserInvitationModal();
    const nextParams = new URLSearchParams(searchParams);
    nextParams.delete('invite');
    const nextSearch = nextParams.toString();
    navigate(
      {
        pathname: location.pathname,
        search: nextSearch ? `?${nextSearch}` : '',
      },
      {replace: true},
    );
  }, [
    location.pathname,
    location.search,
    navigate,
    openGlobalUserInvitationModal,
  ]);
  const {data: counts} = useQuery(['workspace-member-counts'], async () => {
    const controller = new UserAPIController(new UserAPIRequestImpl());
    const [active, invited, suspended] = await Promise.all([
      controller.fetchPaginatedConfirmedUsers(1),
      controller.fetchPaginatedInviteUsers(1),
      controller.fetchPaginatedDeactivatedUsers(1),
    ]);
    return {
      active: active?.totalResults || 0,
      invited: invited?.totalResults || 0,
      suspended: suspended?.totalResults || 0,
    };
  });

  return (
    <MemberPage>
      <MemberPageHeader>
        <MemberPageHeading>
          <MemberPageTitle>Members</MemberPageTitle>
          <MemberPageSubtitle>
            Manage your workspace members, their roles, and team assignments.
          </MemberPageSubtitle>
        </MemberPageHeading>
        {!isFreePlanActive && (
          <Button
            kind="primary"
            style={{height: '46px', padding: '12px 24px'}}
            onClick={openGlobalUserInvitationModal}>
            Invite people
          </Button>
        )}
      </MemberPageHeader>

      <MemberSegments aria-label="Member status">
        <MemberSegment
          type="button"
          $active={memberTab.active}
          onClick={() => activateMemberTab('active')}>
          Active{counts ? ` (${counts.active})` : ''}
        </MemberSegment>
        <MemberSegment
          type="button"
          $active={memberTab.invite}
          onClick={() => activateMemberTab('invite')}>
          Invited{counts ? ` (${counts.invited})` : ''}
        </MemberSegment>
        <MemberSegment
          type="button"
          $active={memberTab.deactivate}
          onClick={() => activateMemberTab('deactivate')}>
          Suspended{counts ? ` (${counts.suspended})` : ''}
        </MemberSegment>
      </MemberSegments>

      {memberTab.active && <Active />}
      {memberTab.invite && <Invite />}
      {memberTab.deactivate && <Deactivate />}
    </MemberPage>
  );
});
